import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-custom-select-v3',
  templateUrl: './custom-select-v3.component.html',
  styleUrls: ['./custom-select-v3.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomSelectV3Component),
      multi: true
    }
  ]
})
export class CustomSelectV3Component implements ControlValueAccessor, OnChanges {


  @Input() options: any[] | string[] = [];
  @Input() placeholder: string = "";
  @Output() selectedOption = new EventEmitter<string>();
  @Input() version: 'V1'
  @Input() designVersion: 'V1'
  @Input() hideIcons: boolean = false;
  @Input() icon: '../../../../../assets/new-icons/order-icon.svg';
  @Input() editMode: boolean = false;
  @Input() optionValue: string;
  @Input() optionName: string


  private onChange: (value: any) => void = () => { };

  ngOnChanges(changes: SimpleChanges): void {

    if (this.editMode) {
      this.placeholder = this.optionName;
      this.selectedValue = this.optionValue;
    }
  }


  private onTouch: () => void = () => { };

  isOpen = false;
  selectedValue: string | undefined;
  selectLabel: string | undefined;


  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  selectOption(option: any | string) {

    if (this.version === 'V1' && typeof option !== 'string') {
      this.selectLabel = option.name;
      this.selectedValue = option.public_id;
    }

    this.isOpen = false;
    this.onChange(this.selectedValue);
    this.onTouch();
    this.selectedOption.emit(this.selectedValue);
  }

  writeValue(value: any | string): void {
    if (this.version === 'V1' && typeof value !== 'string' && value !== undefined) {
      this.selectLabel = value.name;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

}


